/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ArrowIcon } from '../common-view';
import './index.scss';
export default function OPList(props) {
    const { dataSource, renderItem, renderDetails, clickRowOpen = true, hasBorder = true, iconSize = 14, } = props;
    const [openState, setOpenState] = useState([]);
    useEffect(() => {
        // @ts-ignore
        setOpenState(Array(dataSource.length).fill(false));
    }, [dataSource]);
    const changeOpen = (index, from) => {
        if ((clickRowOpen && from === 'icon') ||
            (!clickRowOpen && from === 'item')) {
            return;
        }
        const oldVal = openState[index];
        // @ts-ignore
        openState[index] = !oldVal;
        setOpenState(openState.slice());
    };
    return (React.createElement("div", { className: 'operate-list' }, Array.isArray(dataSource)
        ? dataSource.map((item, index) => (React.createElement("div", { className: classNames('operate-list__item', {
                'operate-list__item_border': hasBorder,
                'operate-list__item_border_first': hasBorder && index === 0,
            }) },
            React.createElement("div", { onClick: () => {
                    changeOpen(index, 'item');
                }, className: 'operate-list__display' },
                React.createElement("div", { onClick: () => {
                        changeOpen(index, 'icon');
                    }, className: classNames('operate-list__icon', {
                        'operate-list__item_seleced': openState[index],
                    }) },
                    React.createElement(ArrowIcon, { size: iconSize, color: '#196EE6' })),
                React.createElement("div", { className: 'operate-list__display-content' }, renderItem instanceof Function
                    ? renderItem(item, index)
                    : null)),
            openState[index] ? (React.createElement("div", { className: 'operate-list__extends' }, renderDetails instanceof Function
                ? renderDetails(item, index)
                : null)) : null)))
        : null));
}
